import { useEffect, useState } from "react";

// hook to determine if a user has scrolled down a specific percentage of the page
// will only trigger once, not over and over if the criteria gets met again
export function useScrollPercentage(threshold = 50): boolean {
  const [passed, setPassed] = useState(false);

  useEffect(() => {
    if (passed) return;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;

      if (scrollPercent >= threshold) {
        setPassed(true);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [passed, threshold]);

  return passed;
}
